import type { ImpositionNode, ImpositionPage } from "#internal"

import { LeafNodes } from "./LeafNodes"

/** Every page under `node`, in tree order. */
export function* LeafPages(node: ImpositionNode): Generator<ImpositionPage> {
  for (const leaf of LeafNodes(node)) yield leaf.page!
}
